import { useEffect, useState } from "react";
import { FaFileMedical } from "react-icons/fa";
import {
  Alert,
  Divider,
  FormControlLabel,
  FormGroup,
  Switch,
  TextField,
  Stack,
} from "@mui/material";
import {
  getCombos,
  getCboMunicipios,
  sql,
  setPlantillaSencilla,
  setUsuario,
  updateUsuario,
} from "../componentes/api.js";
import VentanaCrear from "../comun/VentanaCrear.jsx";
import BarraBotones from "../comun/BarraBotones.jsx";
import BeneficiariosLista from "./BeneficiariosLista.jsx";

const Beneficiarios = (props) => {
  /**Para cargar los datos de los combos */
  const [cargando, setCargando] = useState(false);
  const [cargos, setCargos] = useState([]);
  const [auditores, setAuditores] = useState([]);
  const [tipoDocumentos, setTipoDocumentos] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [mostrarCrear, setMostrarCrear] = useState(false);
  const [actualizaListado, setActualizaListado] = useState(false);

  const [datos, setDatos] = useState({
    idUsuario: "",
    nbres: "",
    apellidos: "",
    noDocumento: "",
    tipoDocumento: "",
    municipio: 0,
    direccion: "",
    celular: "",
    correo: "",
    clave: "",
    tipoParticipante: "3",
    cargo: "1",
    activo: true,
    usuarioReg: props.idUsuario,
    proyecto: props.idProyecto,
    auditor: props.idUsuario,
  });

  useEffect(() => {
    nuevo();
    cargarCombos({ Tabla: "tipo_documento", Campo: "" }, "tipoDocumento");
    cargarMunicipios();
    setCargando(true);
  }, [props.idProyecto]);

  const asignarDato = (event) => {
    event.preventDefault();
    if (event.target.name === "activo") {
      setDatos({ ...datos, [event.target.name]: event.target.checked });
    } else {
      setDatos({ ...datos, [event.target.name]: event.target.value });
    }
  };

  const buscarUsuario = async (doc) => {
    try {
      setCargando(true);
      const response = await sql("getUsuario", "POST", { noDocumento: doc });
      if (response.length !== 0) {
        setDatos({
          ...datos,
          ["idUsuario"]: response[0].Id,
          ["nbres"]: response[0].Nbres,
          ["apellidos"]: response[0].Apellidos,
          ["noDocumento"]: response[0].NoDocumento,
          ["tipoDocumento"]: response[0].TipoDocumento,
          ["municipio"]: response[0].Municipio,
          ["direccion"]: response[0].Direccion,
          ["celular"]: response[0].Celular,
          ["correo"]: response[0].Correo,
          ["tipoParticipante"]: response[0].TipoParticipante,
          ["activo"]:
            response[0].Activo === 1 || response[0].Activo === "1"
              ? true
              : false,
          ["idAuditor"]: props.idUsuario,
          ["cargo"]: "1",
        });
      } else {
        setDatos({
          ...datos,
          ["idUsuario"]: "",
          ["nbres"]: "",
          ["apellidos"]: "",
          //['noDocumento']: datos.NoDocumento,
          // ['tipoDocumento']: response.data[0].TipoDocumento,
          ["municipio"]: "",
          ["direccion"]: "",
          ["celular"]: ",",
          ["correo"]: "",
          ["tipoParticipante"]: "3",
          ["activo"]: true,
          ["idAuditor"]: props.idUsuario,
          ["cargo"]: "1",
        });
      }
      setCargando(false);
    } catch (error) {
      setCargando(false);
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al buscar el número del Documento de Identidad",
        error,
      ]);
    }
  };

  const botones = (boton) => {
    if (boton === 0) nuevo(); //Nuevo
    else if (boton === 1) validarDatos(); //Grabar registro
    else if (boton === 2) imprimir(); //Imprimir registro
    else if (boton === 3) exportar(); //Exportar registro
    else if (boton === 4) nuevo(); //Limpiar, igual a nuevo
  };

  const cargarCombos = async (datos, cbo) => {
    try {
      setCargando(true);
      const response = await getCombos(datos);
      if (cbo === "tipoDocumento") {
        setTipoDocumentos(response.data);
      }
      setCargando(false);
    } catch (error) {
      setCargando(false);
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al cargar los Combos",
        error,
      ]);
    }
  };

  const cargarMunicipios = async () => {
    try {
      setCargando(false);
      const response = await getCboMunicipios();
      setMunicipios(response.data);
      setCargando(false);
    } catch (error) {
      setCargando(false);
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al cargar los Municipios",
        error,
      ]);
    }
  };

  const cerrarVentanaCrear = () => {
    setMostrarCrear(false);
  };

  const exportar = () => {
    props.mostrarMsg(["OK, exportará los datos"]);
  };

  const grabarCampo = async (nbre) => {
    try {
      setCargando(true);
      let plantilla = {
        tabla: "tipo_documento",
        nbre: nbre,
        activo: "1",
        idUsuario: props.idUsuario,
      };
      const response = await setPlantillaSencilla(plantilla);
      setDatos({ ...datos, tipoDocumento: response.data.Id });
      cargarCombos({ Tabla: "tipo_documento", Campo: "" }, "tipoDocumento");
      setCargando(false);
    } catch (error) {
      setCargando(false);
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al Grabar el Tipo de Documento",
        error,
      ]);
    }
  };

  const grabarRegistro = async () => {
    try {
      setCargando(true);
      const result = await setUsuario(datos);
      setActualizaListado(true);
      setCargando(false);
      props.mostrarMsg(["Usuario Creado!"]);
    } catch (error) {
      setCargando(false);
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al Grabar al Beneficiario del Proyecto",
        error,
      ]);
    }
  };

  const imprimir = () => {
    props.mostrarMsg(["OK, Imprime los datos"]);
  };

  const modificarRegistro = async () => {
    try {
      setCargando(true);
      setActualizaListado(false);
      const resp = await updateUsuario(datos);
      setActualizaListado(true);
      setCargando(false);
      if (
        resp.data.result.affectedRows === 1 ||
        resp.data.result.affectedRows === "1"
      ) {
        props.mostrarMsg(["Datos del Usuario actualizados!"]);
      } else {
        props.mostrarMsg(["No se pudieron actualizar los datos del Usuario!"]);
      }
    } catch (error) {
      setCargando(false);
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al Modificar los Datos del Beneficiario del Proyecto",
        error,
      ]);
    }
  };

  const mostrarVentanaCrear = (event, titulo) => {
    event.preventDefault();
    setMostrarCrear(true);
  };

  const nuevo = () => {
    setDatos({
      idUsuario: "",
      nbres: "",
      apellidos: "",
      noDocumento: "",
      tipoDocumento: datos.tipoDocumento || "",
      municipio: datos.municipio || 0,
      direccion: "",
      celular: "",
      correo: "",
      clave: "",
      tipoParticipante: datos.tipoParticipante || "2",
      activo: true,
      usuarioReg: props.idUsuario,
      proyecto: props.idProyecto,
      auditor: props.idUsuario,
      cargo: "1",
    });
  };

  const validarDatos = () => {
    setCargando(true);
    if (datos.nbres === "") {
      props.mostrarMsg(["Por favor digite los Nombres!"]);
      setCargando(false);
    } else if (datos.apellidos === "") {
      props.mostrarMsg(["Por favor digite los Apellidos!"]);
      setCargando(false);
    } else if (datos.tipoDocumento === "") {
      props.mostrarMsg(["Por favor digite el Tipo de Documento!"]);
      setCargando(false);
    } else if (datos.noDocumento === "") {
      props.mostrarMsg(["Por favor digite el Número de Documento!"]);
      setCargando(false);
    } else if (datos.municipio === "") {
      props.mostrarMsg(["Por favor seleccione un Municipio!"]);
      setCargando(false);
    } else if (datos.direccion === "") {
      props.mostrarMsg(["Por favor digite la Dirección!"]);
      setCargando(false);
    } else if (datos.celular === "") {
      props.mostrarMsg(["Por favor digite el Número de Celular!"]);
      setCargando(false);
    } else if (datos.clave === "" && datos.id === "") {
      props.mostrarMsg([
        "Por favor digite una Clave de Acceso a la Plataforma!",
      ]);
      setCargando(false);
    } else {
      {
        datos.idUsuario === "" ? grabarRegistro() : modificarRegistro();
      }
    }
  };

  return (
    <>
      <div className="container-fluid card shadow mt-2" id="divTop">
        <div className="row mt-3 mb-3">
          <Stack sx={{ width: "100%" }} spacing={2}>
            <Alert severity="success">
              <strong>BENEFICIARIOS DEL PROYECTO</strong>
            </Alert>
            {cargando === true && (
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Cargando...</span>
              </div>
            )}
          </Stack>
        </div>

        <div className="row mt-3">
          <Divider component="ul" />
          <BarraBotones
            botones={botones}
            btnActivos={[true, true, false, true, true]}
          />
        </div>

        <hr />

        <div className="container-fluid" id="divTop">
          <div className="row">
            <div className="col-sm-6">
              <div className="input-group form-floating mt-2">
                <select
                  name="tipoDocumento"
                  className="form-select form-control"
                  aria-label="tipoDocumento"
                  value={datos.tipoDocumento}
                  onChange={(event) => asignarDato(event)}
                >
                  <option key="0" value="0">
                    Por favor seleccione un Tipo de Documento...
                  </option>
                  {tipoDocumentos.map((reg) => {
                    return (
                      <option key={reg.Id} value={reg.Id} label={reg.Nbre}>
                        {" "}
                        {reg.Nbre}{" "}
                      </option>
                    );
                  })}
                </select>
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={(event) => {
                    mostrarVentanaCrear(event, "TIPO DE DOCUMENTOS");
                  }}
                >
                  <FaFileMedical />
                </button>
              </div>
            </div>

            <div className="col-sm-6">
              <div className="row mt-2">
                <TextField
                  style={{ marginTop: "10px" }}
                  InputLabelProps={{ shrink: true }}
                  name="noDocumento"
                  label="Número de Documento de Identidad"
                  className="form-control"
                  onChange={(event) => asignarDato(event)}
                  onBlur={(event) => buscarUsuario(event.target.value)}
                  type="text"
                  value={datos.noDocumento}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-6">
              <TextField
                style={{ marginTop: "10px" }}
                InputLabelProps={{ shrink: true }}
                name="nbres"
                label="Nombres"
                className="form-control"
                onChange={(event) => asignarDato(event)}
                type="text"
                value={datos.nbres}
              />
            </div>

            <div className="col-sm-6">
              <TextField
                style={{ marginTop: "10px" }}
                InputLabelProps={{ shrink: true }}
                name="apellidos"
                label="Apellidos"
                className="form-control"
                onChange={(event) => asignarDato(event)}
                type="text"
                value={datos.apellidos}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-sm-6">
              <div className="row form-floating mt-2">
                <select
                  type="text"
                  className="form-control"
                  name="municipio"
                  value={datos.municipio}
                  onChange={(event) => {
                    asignarDato(event);
                  }}
                >
                  <option key="0" value="0">
                    Por favor seleccione un Municipio...
                  </option>
                  {municipios.map((reg) => {
                    return (
                      <option key={reg.Id} value={reg.Id} label={reg.Nbre}>
                        {" "}
                        {reg.Nbre}{" "}
                      </option>
                    );
                  })}
                </select>
                <label htmlFor="municipio">Municipio de Residencia</label>
              </div>
            </div>

            <div className="col-sm-6">
              <TextField
                style={{ marginTop: "10px" }}
                InputLabelProps={{ shrink: true }}
                name="direccion"
                label="Dirección de Residencia"
                className="form-control"
                onChange={(event) => asignarDato(event)}
                type="text"
                value={datos.direccion}
              />
            </div>
          </div>

          <div className="row mt-2">
            <TextField
              style={{ marginTop: "10px" }}
              InputLabelProps={{ shrink: true }}
              name="celular"
              label="Número de Celular de Contacto"
              className="form-control"
              onChange={(event) => asignarDato(event)}
              type="text"
              value={datos.celular}
            />
          </div>

          <div className="row">
            <div className="col-sm-6">
              <TextField
                style={{ marginTop: "10px" }}
                InputLabelProps={{ shrink: true }}
                name="correo"
                label="Dirección de Correo"
                className="form-control"
                onChange={(event) => asignarDato(event)}
                type="text"
                value={datos.correo}
              />
            </div>
            <div className="col-sm-6">
              <TextField
                style={{ marginTop: "10px" }}
                InputLabelProps={{ shrink: true }}
                name="clave"
                label="Clave de Acceso"
                className="form-control"
                onChange={(event) => asignarDato(event)}
                type="password"
                value={datos.clave}
              />
            </div>
          </div>

          {datos.tipoParticipante === "2" && (
            <div className="row mt-3">
              <div className="col-sm-6">
                <div className="row form-floating mt-2">
                  <select
                    type="text"
                    className="form-control"
                    name="cargo"
                    value={datos.cargo}
                    onChange={(event) => asignarDato(event)}
                  >
                    <option key="0" value="0">
                      Por favor seleccione un Componente...
                    </option>
                    {cargos.map((reg) => {
                      return (
                        <option key={reg.Id} value={reg.Id} label={reg.Nbre}>
                          {" "}
                          {reg.Nbre}{" "}
                        </option>
                      );
                    })}
                  </select>
                  <label htmlFor="cargo">Componente del Equipo</label>
                </div>
              </div>

              <div className="col-sm-6">
                <div className="row form-floating mt-2">
                  <select
                    type="text"
                    className="form-control"
                    name="auditor"
                    value={datos.auditor}
                    onChange={(event) => asignarDato(event)}
                  >
                    <option key="0" value="0">
                      Por favor seleccione un Auditor...
                    </option>
                    {auditores.map((reg) => {
                      return (
                        <option key={reg.Id} value={reg.Id} label={reg.Nbres}>
                          {" "}
                          {reg.Nbres}{" "}
                        </option>
                      );
                    })}
                  </select>
                  <label htmlFor="auditor">
                    Funcionario que hace Seguimiento
                  </label>
                </div>
              </div>
            </div>
          )}

          <div className="row mt-2">
            <Alert severity="info">
              <strong>
                {" "}
                La siguiente opción permite ver el estado en el cual se
                encuentra el Beneficiario
                <br />
              </strong>
            </Alert>
            <FormGroup>
              <FormControlLabel
                name="activo"
                control={
                  <Switch
                    size="large"
                    checked={datos.activo}
                    onChange={(event) => asignarDato(event)}
                    inputProps={{ "aria-label": "Activo" }}
                  />
                }
                label={
                  datos.activo === true ? "Estado: Activo" : "Estado: INACTIVO"
                }
                labelPlacement="start"
              />
            </FormGroup>
          </div>

          <div className="row mt-3">
            <Divider component="ul" />
            <BarraBotones
              botones={botones}
              btnActivos={[true, true, false, true, true]}
            />
          </div>

          {mostrarCrear === true && (
            <VentanaCrear
              titulo={"TIPO DE DOCUMENTO"}
              grabarCampo={grabarCampo}
              mostrarCrear={mostrarCrear}
              setMostrarCrear={setMostrarCrear}
            />
          )}
        </div>

        <BeneficiariosLista
          proyecto={props.idProyecto}
          actualizaListado={actualizaListado}
          setCargando={setCargando}
        />
      </div>
    </>
  );
};

export default Beneficiarios;
